import { render, staticRenderFns } from "./SelectBatchComponent.vue?vue&type=template&id=1930982c"
import script from "./SelectBatchComponent.vue?vue&type=script&lang=js"
export * from "./SelectBatchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports